var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.377,
    height: 29.215,
    viewBox: "0 0 25.377 29.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#333;}.a{stroke-linecap:round;stroke-linejoin:round;}.b{stroke-linejoin:bevel;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2587.261 -852.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2595.223 861.126)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2606.275,875.854v5.721l4.643,2.695,4.643-2.695v-5.721l-4.643-2.695Z",
    transform: "translate(-2606.275 -873.16)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 7.818,
    transform: "translate(4.643 5.78)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2587.761 858.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2587.761,868.117v3.08l2.654,1.54,2.653-1.54v-3.08l-2.653-1.54Z",
    transform: "translate(-2587.761 -866.577)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 2.369,
    y2: 1.374,
    transform: "translate(0.284 1.706)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2606.831 858.472)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2635.074,868.117v3.08l2.653,1.54,2.653-1.54v-3.08l-2.653-1.54Z",
    transform: "translate(-2635.074 -866.577)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y1: 1.374,
    x2: 2.369,
    transform: "translate(2.653 1.706)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2587.761 869.749)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2587.761,896.093v3.08l2.654,1.54,2.653-1.54v-3.08l-2.653-1.54Z",
    transform: "translate(-2587.761 -894.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2588.466,896.259l2.369,1.374,4.975-3.08",
    transform: "translate(-2588.182 -894.553)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 2.701,
    transform: "translate(2.653 3.079)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2604.344 869.583)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2635.074,896.093v3.08l2.653,1.54,2.653-1.54v-3.08l-2.653-1.54Z",
    transform: "translate(-2632.587 -894.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2628.9,894.142l5.141,3.245,2.369-1.374",
    transform: "translate(-2628.903 -894.142)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 2.701,
    transform: "translate(5.141 3.245)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2597.213 853)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2611.212,854.54v3.08l2.653,1.54,2.654-1.54v-3.08l-2.654-1.54Z",
    transform: "translate(-2611.212 -853)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2611.917,857.232l2.369,1.374,2.369-1.374",
    transform: "translate(-2611.633 -855.526)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 4.781,
    transform: "translate(2.653 3.079)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2597.213 875.055)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2611.212,909.259v3.08l2.653,1.54,2.654-1.54v-3.08l-2.654-1.54Z",
    transform: "translate(-2611.212 -907.719)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 2.701,
    transform: "translate(2.653 3.079)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2600.949,905.931l6.812,3.856,6.989-3.856",
    transform: "translate(-7.872 -31.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2601.143,864.52l-6.8,4.021v7.918",
    transform: "translate(-3.929 -6.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2631.342,876.625v-8.084l-6.965-4.021",
    transform: "translate(-21.857 -6.877)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2600.926,877.685l6.8,3.98,6.965-3.98",
    transform: "translate(-7.859 -14.735)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.9b4f98ca905cbccf0e07367c70908d1e.svg";
export { ForwardRef as ReactComponent };